"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageMaskSchema = void 0;
var yup = __importStar(require("yup"));
exports.ImageMaskSchema = yup.object({
    x: yup
        .number()
        .min(0)
        .max(100),
    y: yup
        .number()
        .min(0)
        .max(100),
    width: yup
        .number()
        .min(0)
        .max(100),
    height: yup
        .number()
        .min(0)
        .max(100),
    svgId: yup.string(),
    flip: yup
        .mixed()
        .oneOf(['x', 'y', 'xy', 'none'])
        .default('none')
        .meta({
        description: 'Defines whether the mask is flipped on the v or h axis',
    }),
    rotate: yup
        .number()
        .min(0)
        .max(360),
    mode: yup
        .mixed()
        .oneOf(['alpha', 'luminance'])
        .default('alpha'),
});
//# sourceMappingURL=ImageMask.schema.js.map